import Vue from 'vue'
import App from './App.vue'


Vue.config.productionTip = false
var el = document.getElementById("featuredNews-vue");

new Vue({
  name: 'FeaturedNews',
  data:{
    elementSettings: {
      language: JSON.parse(el.dataset.language),
      tagId: (el.dataset.tagid || "").trim()
    }
  },  
  
  render: h => h(App),
}).$mount('#featuredNews-vue')


